/**
 * R202: Reputation rewards — items, доступные за tier репутации.
 * Vanilla pattern: каждая main фракция имеет quartermaster, продающий gear
 * gated by Friendly/Honored/Revered/Exalted.
 */

import type { RepTier } from './reputations.js';

export interface RepReward {
  factionId: string;
  itemId: string;
  tierRequired: Exclude<RepTier, 'Hated' | 'Hostile' | 'Unfriendly' | 'Neutral'>;
  /** Цена в Storm Crystals. */
  price: number;
}

export const REP_REWARDS: RepReward[] = [
  // ── Stormwind ──
  { factionId: 'stormwind', itemId: 'stormwind-vanguard-tabard', tierRequired: 'Friendly', price: 100 },
  { factionId: 'stormwind', itemId: 'cloak-of-storms',           tierRequired: 'Honored',  price: 800 },
  { factionId: 'stormwind', itemId: 'helm-of-three-winds',       tierRequired: 'Revered',  price: 5000 },
  { factionId: 'stormwind', itemId: 'tier1-warrior-helm',        tierRequired: 'Exalted',  price: 15000 },
  // ── Ironforge ──
  { factionId: 'ironforge', itemId: 'dwarven-warhammer',         tierRequired: 'Friendly', price: 200 },
  { factionId: 'ironforge', itemId: 'mithril-greatsword',        tierRequired: 'Honored',  price: 900 },
  { factionId: 'ironforge', itemId: 'belt-of-the-warlord',       tierRequired: 'Revered',  price: 5000 },
  { factionId: 'ironforge', itemId: 'thoraddins-belt',           tierRequired: 'Exalted',  price: 22000 },
  // ── Darnassus ──
  { factionId: 'darnassus', itemId: 'darnassus-cloak',           tierRequired: 'Friendly', price: 150 },
  { factionId: 'darnassus', itemId: 'mystic-cape',               tierRequired: 'Honored',  price: 800 },
  { factionId: 'darnassus', itemId: 'tier1-druid-cap',           tierRequired: 'Revered',  price: 5000 },
  { factionId: 'darnassus', itemId: 'tier2-druid-shoulders',     tierRequired: 'Exalted',  price: 18000 },
  // ── Gnomeregan ──
  { factionId: 'gnomeregan-x', itemId: 'pet-mech-squirrel',      tierRequired: 'Friendly', price: 250 },
  { factionId: 'gnomeregan-x', itemId: 'mount-mechanostrider',   tierRequired: 'Honored',  price: 800 },
  { factionId: 'gnomeregan-x', itemId: 'arcane-orb',             tierRequired: 'Exalted',  price: 14000 },

  // ── Orgrimmar ──
  { factionId: 'orgrimmar', itemId: 'orcish-cleaver',            tierRequired: 'Friendly', price: 200 },
  { factionId: 'orgrimmar', itemId: 'demonblade',                tierRequired: 'Honored',  price: 900 },
  { factionId: 'orgrimmar', itemId: 'frostwolf-chestguard',      tierRequired: 'Revered',  price: 5000 },
  { factionId: 'orgrimmar', itemId: 'tier1-shaman-headdress',    tierRequired: 'Exalted',  price: 18000 },
  // ── Thunder Bluff ──
  { factionId: 'thunder-bluff', itemId: 'tauren-totem-mace',     tierRequired: 'Friendly', price: 200 },
  { factionId: 'thunder-bluff', itemId: 'mount-tauren-kodo',     tierRequired: 'Honored',  price: 900 },
  { factionId: 'thunder-bluff', itemId: 'tier1-shaman-headdress',tierRequired: 'Revered',  price: 5000 },
  { factionId: 'thunder-bluff', itemId: 'tier2-druid-chest',     tierRequired: 'Exalted',  price: 22000 },
  // ── Undercity ──
  { factionId: 'undercity-rep', itemId: 'mount-undead-skelhorse',tierRequired: 'Friendly', price: 250 },
  { factionId: 'undercity-rep', itemId: 'shadow-dagger',         tierRequired: 'Honored',  price: 800 },
  { factionId: 'undercity-rep', itemId: 'tier1-warlock-hood',    tierRequired: 'Revered',  price: 5500 },
  { factionId: 'undercity-rep', itemId: 'tier2-warlock-chest',   tierRequired: 'Exalted',  price: 22000 },
  // ── Darkspear ──
  { factionId: 'darkspear', itemId: 'troll-spear',               tierRequired: 'Friendly', price: 200 },
  { factionId: 'darkspear', itemId: 'mount-troll-raptor',        tierRequired: 'Honored',  price: 900 },
  { factionId: 'darkspear', itemId: 'tier1-rogue-mask',          tierRequired: 'Revered',  price: 5000 },

  // ── Neutral: Argent Dawn ──
  { factionId: 'argent-dawn', itemId: 'tier1-paladin-helm',      tierRequired: 'Honored',  price: 4500 },
  { factionId: 'argent-dawn', itemId: 'tier1-priest-hood',       tierRequired: 'Revered',  price: 9000 },
  { factionId: 'argent-dawn', itemId: 'tier3-paladin-helm',      tierRequired: 'Exalted',  price: 30000 },
  // ── Cenarion Circle ──
  { factionId: 'cenarion-circle', itemId: 'tier1-druid-cap',     tierRequired: 'Honored',  price: 4500 },
  { factionId: 'cenarion-circle', itemId: 'tier3-druid-helm',    tierRequired: 'Exalted',  price: 28000 },
  // ── Thorium Brotherhood ──
  { factionId: 'thorium-bro', itemId: 'thorium-shield',          tierRequired: 'Honored',  price: 4500 },
  { factionId: 'thorium-bro', itemId: 'plate-of-might',          tierRequired: 'Revered',  price: 9000 },
  { factionId: 'thorium-bro', itemId: 'sulfuras-hand',           tierRequired: 'Exalted',  price: 50000 },
  // ── Ravenholdt ──
  { factionId: 'ravenholdt', itemId: 'shadow-dagger',            tierRequired: 'Honored',  price: 4500 },
  { factionId: 'ravenholdt', itemId: 'tier2-rogue-shoulders',    tierRequired: 'Exalted',  price: 28000 },
  // ── Gadgetzan / Steamwheedle Cartel ──
  { factionId: 'gadgetzan', itemId: 'mount-mechanostrider',      tierRequired: 'Friendly', price: 500 },
  { factionId: 'gadgetzan', itemId: 'pet-mech-squirrel',         tierRequired: 'Honored',  price: 1500 },
  // ── Darkmoon Faire ──
  { factionId: 'darkmoon', itemId: 'rune-of-the-guard-captain',  tierRequired: 'Friendly', price: 300 },
  { factionId: 'darkmoon', itemId: 'eye-of-divinity',            tierRequired: 'Exalted',  price: 25000 },
];

export function rewardsByFaction(factionId: string): RepReward[] {
  return REP_REWARDS.filter((r) => r.factionId === factionId);
}
